const context = require.context(".", false, /\.js$/);
const gsapAnimations = {};

context.keys().forEach((file) => {
    if (file !== "./index.js") {
        try {
            Object.assign(gsapAnimations, context(file).default);
        } catch (error) {
            console.error(`Failed to load ${file}:`, error);
        }
    }
});

export default gsapAnimations;
